import React from 'react'
import AllTesti from '../Components/AllTestimonial/AllTesti'

const AllTestiPage = () => {
  return (
    <div>
      <AllTesti/>
    </div>
  )
}

export default AllTestiPage
